import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../utils/urls";

export const subjectSubtutorApi = createApi({
  reducerPath: "subjectSubtutorApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }), // schedules
  endpoints: (builder) => ({
    getSubtutorSubjectsByClassIds: builder.mutation({
      query: (classids) => {
        console.log("Create Event: ", classids);
        return {
          url: `subtutor/get-subjects-by-classids`,
          method: "POST",
          body: { classIdsArray: classids },
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
  }),
});

export const { useGetSubtutorSubjectsByClassIdsMutation } = subjectSubtutorApi;
